import Auth from '../../../modules/Auth';
import Global from '../../../constants/Global';

export async function postGarageMessage({ commit }, { id, text, user }) {
  fetch(Global.getServerDomain() + `/messages/garage/${id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'auth_key': Auth.getToken()
    },
    body: JSON.stringify({
      msg: text
    })
  }).then(res => {
    return res.json()
  }).then(payload => {
    payload.sender = user;
    commit("garage_post_messages", payload);
  }).catch(error => console.error(error))
}